import { Component, ViewChild } from "@angular/core";
import { AuthService } from "../../../../shared/services/auth.service";
import { VehiclesService } from "../../../../shared/services/vehicles.service";
import { ConductorVehiculoService } from "../../../../shared/services/conductor.service";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbAccordion } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { forkJoin } from "rxjs";
import { Administracion } from "../../../../shared/model/administracion.model";
import { AdministracionService } from "../../../../shared/services/administracion.services";
declare var require: any;
const Swal = require("sweetalert2");

@Component({
  selector: "app-elaborar",
  templateUrl: "./elaborar.component.html",
  styleUrls: ["./elaborar.component.scss"],
})
export class ElaborarComponent {
  @ViewChild("accordion", { static: false }) accordion!: NgbAccordion;

  formNuevo!: FormGroup;
  datosListos: boolean = false;
  hayConductoresVigentes: boolean  = false;
  respuestaVehiculos: any;
  conductores: any[] = [];
  conductorSeleccionado: any = null;
  estadoFechasSeleccionadas: any[] = [];
  placa: string = "";
  resultadoExtracto: any[] = [];
  vehiculoSeleccionado: any = null; // ← Aquí guardas los datos para mostrar
  vehiculos: { placa: string }[] = [];
  documentos: any[] = [];
  pageSize1: number = 5;
  page1: number = 1;
  totalItems!: number;
  administraciones: Administracion[] = [];
 usuarioLogin: any | null = null;
 esUsuarioTenant: boolean = false;
 idUser: number | null = null;
 cargandoVehiculo: boolean = false;
  constructor(
    private vehiclesService: VehiclesService,
    private conductorService: ConductorVehiculoService,
    private administracionesServices: AdministracionService,
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService // Agregar el servicio de autenticación
  ) {}

  ngOnInit() {

    this.usuarioLogin = this.authService.getCurrentUserValue();
    this.idUser = this.usuarioLogin?.id ?? null;
 // console.log('🔍 Usuario Login completo:', this.idUser);
  
  // Validar si el usuario es tenant
  if (this.usuarioLogin?.roles) {
    this.esUsuarioTenant =  this.usuarioLogin.roles.includes('USUARIO_TENANT');
  
  }

  if (this.idUser !== null) {
    if (this.esUsuarioTenant) {
        // Lógica específica para usuarios tenant si es necesario
            this.vehiclesService.getVehiculosByUser(this.idUser!).subscribe(
        (data) => {
        //  console.log(data);
          this.vehiculos = data; // ← esto ahora es un array de placas
          
        },
        (error) => {
          console.error("Error al obtener las placas:", error);
        }
      );
    }else{
      this.vehiclesService.getPlacas().subscribe(
        (data) => {
        //  console.log(data);
          this.vehiculos = data; // ← esto ahora es un array de placas
          
        },
        (error) => {
          console.error("Error al obtener las placas:", error);
        }
      );
    }

  }

   this.cargarDataAdmin();
        

    this.formNuevo = this.fb.group({
      placa: [null],
    });
  }

  

onPlacaSeleccionada(vehiculo: { placa: string; relacion: string }) {
  if (!vehiculo || !vehiculo.placa) return;

  const placa = vehiculo.placa;

  // ⏳ Mostrar loading y limpiar datos anteriores mientras carga la info
  this.cargandoVehiculo = true;
  this.datosListos = false;
  this.hayConductoresVigentes = false;
  this.vehiculoSeleccionado = null;

  forkJoin({
    vehiculo: this.vehiclesService.getFechaMaximaPorPlaca(placa),
    conductores: this.conductorService.getConductoresPorPlaca(placa),
  }).subscribe(
    ({ vehiculo, conductores }) => {
      this.cargandoVehiculo = false;
      console.log("Resultado del forkJoin:", { vehiculo, conductores });
      const resultado = {
        ...vehiculo,
        conductores,
        relacion: vehiculo.relacion || vehiculo.relacion,
      };

      
      this.vehiculoSeleccionado = resultado;
      console.log(this.vehiculoSeleccionado);
      // 🔍 Documentos a verificar
      const documentos = [
        { key: 'tarjetaOperacion', label: 'Tarjeta de Operación' },
        { key: 'soat', label: 'SOAT' },
        { key: 'cda', label: 'CDA' },
        { key: 'revisionBimestral', label: 'Revisión Bimestral' },
        { key: 'contractual', label: 'Seguro Contractual' },
        { key: 'extracontractual', label: 'Seguro Extracontractual' },
         { key: 'convenio', label: 'CONVENIO' },
      ];

      if (this.validarPreoActivo(resultado)) {
        documentos.push({ key: 'ultimoAlistamiento', label: 'Alistamiento Diario' });
      }

      if (this.validarRodamientoActivo(resultado)) {
        documentos.push({ key: 'rodamiento', label: 'Rodamiento' });
      }

      
      const documentosVencidos = documentos.filter(({ key }) => {
        const doc = resultado[key];
        return doc?.estado === 'VENCIDO';
      });

      if (documentosVencidos.length > 0) {
         this.datosListos = false;
        const nombres = documentosVencidos.map((d) => `• ${d.label}`).join('\n');
        this.mostrarAlertaVencido(
          `Los siguientes documentos están vencidos:\n${nombres}`
        );
      }else{

         this.datosListos = true;
         this.hayConductoresVigentes = this.tieneAlMenosUnConductorVigente();
         if(!this.hayConductoresVigentes){
          Swal.fire({
              icon: 'warning',
              title: 'Validar Fechas',
              text:'Validar las fechas de Licencia y/o  Seguridad Social, al menos debes tener un conductor con fechas válidas',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: 'bg-primary',
            });
         } 
          console.log(this.hayConductoresVigentes);
      }



    },
    (error) => {
      this.cargandoVehiculo = false;
      if (error.status === 404) {
      Swal.fire({
        icon: 'warning',
        title: 'Sin conductores',
        text: error.error?.error || 'No se encontraron datos para esta placa',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: 'bg-primary',
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ocurrió un error inesperado. Intente nuevamente.',
        confirmButtonText: 'Aceptar',
      });
    }
  
      this.vehiculoSeleccionado = null;
    }
  );
}



  // Función para mostrar la alerta tipo Swal
  mostrarAlertaVencido(mensaje: string): void {
    Swal.fire({
      icon: "warning",
      title: "Fechas vencidas",
      text: mensaje,
      confirmButtonText: "Aceptar",
      confirmButtonColor: "bg-primary",
    });

  }



  getEstadoLicencia(fechaStr: string | undefined): string {
    if (!fechaStr) return "SIN FECHA";

    const hoy = new Date();
    const vencelic = new Date(fechaStr);
    const diffDias = (vencelic.getTime() - hoy.getTime()) / (1000 * 3600 * 24);

    if (diffDias < 0) return "VENCIDO";
    if (diffDias <= 30) return "POR VENCER";
    return "VIGENTE";
  }

  getEstadoColor(estado: string): string {
    switch (estado) {
      case "VIGENTE":
        return "bg-success text-white";
      case "POR VENCER":
        return "bg-warning text-dark";
      case "VENCIDO":
        return "bg-danger text-white";
      default:
        return "bg-secondary text-white";
    }
  }

  // En el componente .ts

  onSeleccionarPlaca(placa: string): void {
    this.vehiculoSeleccionado = placa;
  }

  crearExtracto(): void {

    const placa = this.vehiculoSeleccionado?.placa;
    const fechaMaxima = this.vehiculoSeleccionado?.fechamax;
    console.log(fechaMaxima)  ;

    if (!placa) {
      console.warn("No hay placa seleccionada.");
      return;
    }

    this.router.navigate(["/Extractos/crear-extracto", placa], {
      state: { fechaMaxima },
    });
  }

  hayDocumentoVencido(): boolean {
    return this.documentos.some((doc) => doc.estado === "VENCIDO");
  }

tieneAlMenosUnConductorVigente(): boolean {
  const hoy = new Date();
  console.log(this.vehiculoSeleccionado)
  return this.vehiculoSeleccionado.conductores.some((conductor: any) => {
    const vencelic = conductor.propietario?.vencelic ? new Date(conductor.propietario.vencelic) : null;
    const fechacobeps = conductor.propietario?.fechacobeps ? new Date(conductor.propietario.fechacobeps) : null;

    return (
      (!vencelic || vencelic >= hoy) &&
      (!fechacobeps || fechacobeps >= hoy)
    );
  });
}

 estadoMap: { [key: string]: string } = {
    VIGENTE: "badge badge-light-success",
    "POR VENCER": "badge badge-light-warning",
    VENCIDO: "badge badge-light-secondary",
  };

  getEstadoColorDocu(estado: string | undefined): string {
    return this.estadoMap[estado || ""] || "badge badge-light-primary"; // Si no hay estado, usa gris
  }

  getDiasAlistamiento(ultimoAlistamiento: any): number {
    const dias = Number(ultimoAlistamiento?.diasDesde ?? 0);
    if (Number.isNaN(dias)) {
      return 0;
    }

    const estado = String(ultimoAlistamiento?.estado ?? '').toUpperCase();
    return estado === 'VENCIDO' ? -Math.abs(dias) : Math.abs(dias);
  }

  validarPreoActivo(vehiculo?: any): boolean {
    const admin = this.obtenerAdministracionVehiculo(vehiculo);
    const valor = admin?.validarPreo ?? admin?.validarpreo ?? 0;
    return Number(valor) === 1;
  }

  validarRodamientoActivo(vehiculo?: any): boolean {
    const admin = this.obtenerAdministracionVehiculo(vehiculo);
    const valor = admin?.validarRodamiento
    
      ?? 0;
    return Number(valor) === 1;
  }

  private obtenerAdministracionVehiculo(vehiculo?: any): Administracion | any {
    const dataVehiculo = vehiculo ?? this.vehiculoSeleccionado;
    const nitAdmin = dataVehiculo?.nitAdministracion
      ?? dataVehiculo?.idAdministracion
      ?? dataVehiculo?.nit
      ?? dataVehiculo?.empresaNit
      ?? null;

    if (nitAdmin !== null && nitAdmin !== undefined) {
      const encontrada = this.administraciones.find((a: any) => Number(a?.nit) === Number(nitAdmin));
      if (encontrada) {
        return encontrada;
      }
    }

    return this.administraciones?.[0] ?? null;
  }

  
   private cargarDataAdmin(): void {
    this.administracionesServices.obtenerTodas().subscribe({
      next: (data) => {

        this.administraciones = data;
       //   console.log('Administraciones cargadas:', this.administraciones);
      
      },
      error: (err) => {
        console.error("Error al cargar los conductores:", err);
      },
    });
  }


}